import { userName } from '@/Ship/Helpers/fieldViews'

import type { DiskFileKind, DiskStorage, DiskUserRef } from '../Contracts/DiskNode'

const UNITS = ['Б', 'КБ', 'МБ', 'ГБ', 'ТБ']

/** Розмір для людини: «812 Б», «4,2 МБ», «10 ГБ». Двійкові кратні, як рахує квота беку. */
export const formatBytes = (bytes: number): string => {
    if (!Number.isFinite(bytes) || bytes <= 0) return '0 Б'

    let value = bytes
    let unit = 0

    while (value >= 1024 && unit < UNITS.length - 1) {
        value /= 1024
        unit += 1
    }

    const digits = unit === 0 || value >= 100 ? 0 : 1
    const text = value.toFixed(digits).replace(/\.0$/, '').replace('.', ',')

    return `${text} ${UNITS[unit]}`
}

/** «1 елемент», «3 елементи», «12 елементів». */
export const pluralUk = (count: number, one: string, few: string, many: string): string => {
    const mod10 = count % 10
    const mod100 = count % 100

    if (mod10 === 1 && mod100 !== 11) return one
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few

    return many
}

export const itemsCount = (count: number): string => `${count} ${pluralUk(count, 'елемент', 'елементи', 'елементів')}`

/** Підпис виду файлу — для плитки, інфопанелі й підказки до іконки. */
export const KIND_LABEL: Record<DiskFileKind, string> = {
    folder: 'Папка',
    image: 'Зображення',
    pdf: 'PDF',
    video: 'Відео',
    audio: 'Аудіо',
    text: 'Текст',
    document: 'Документ',
    spreadsheet: 'Таблиця',
    presentation: 'Презентація',
    archive: 'Архів',
    other: 'Файл',
}

/** Розширення для підпису плитки: «PDF», «XLSX». */
export const fileExtension = (name: string): string => {
    const dot = name.lastIndexOf('.')

    return dot > 0 && dot < name.length - 1 ? name.slice(dot + 1).toUpperCase() : ''
}

export const personName = (user: DiskUserRef | null): string => (user === null ? '—' : userName(user) || '—')

/** Підпис простору в навігації: «Мій диск», «Компанія», назва відділу. */
export const storageTitle = (storage: Pick<DiskStorage, 'type' | 'title'>): string =>
    storage.type === 'personal' ? 'Мій диск' : storage.title
